<ion-list lines="none" id="reset-form-list">
  <ion-item lines="none" class="ion-no-padding">
    <ion-input id="username" type="email" name="username" placeholder="Email Address*" [(ngModel)]="email">
    </ion-input>
  </ion-item>
  <p *ngIf="step === 1">Enter the email you used to register your account above. Then click send to receive an
    email containing a
    link to reset your password</p>
  <p *ngIf="step === 2">
    <ion-text color="secondary">A reset link has been sent to {{email}}. It may take a few minutes to arrive. If
      you do not receive an email and have checked your spam box, add support@bidbeacon.com to your contact list,
      and request another link.</ion-text>
  </p>

  <ion-button [hidden]="pageState.busy" shape="round" size="block" (click)="reset()">Send</ion-button>

  <div class="ion-text-center" [hidden]="!pageState.busy">
    <ion-spinner name="dots" color="login-color"></ion-spinner>
  </div>

  <div class="ion-text-center">
    <ion-button size="block" fill="clear" class="bold create-btn" [disabled]="pageState.busy" (click)="goToLogin()">
      Back To Login
    </ion-button>
  </div>

</ion-list>